import { useState, useLayoutEffect } from 'react';

const clamp = (value) => Math.max(0, value);

const isBetween = (value, floor, ceil) => value >= floor && value <= ceil;

const isSkipOnScreen = (selectedTab) => selectedTab !== 'history';

export default (ids = [], offset = 0, selectedTab) => {
  const [activeId, setActiveId] = useState(ids.length > 0 ? ids[0] : '');

  useLayoutEffect(() => {
    const listener = () => {
      if (isSkipOnScreen(selectedTab)) {
        const scroll = window.scrollY;

        const position = ids
          .map((id) => {
            const element = document.getElementById(id);
            if (!element) {
              return { id, top: -1, bottom: -1 };
            }

            const nestedOffset = id === 'distributor_sale' ? 100 : 0;
            const rect = element?.getBoundingClientRect();
            const top = clamp(rect.top + scroll - offset - nestedOffset);
            const bottom = clamp(rect.bottom + scroll - offset);

            return { id, top, bottom };
          })
          .find(({ top, bottom }) => isBetween(scroll, top, bottom));

        setActiveId(position?.id || ids[0]);
      }
    };

    listener();

    window.addEventListener('resize', listener);
    window.addEventListener('scroll', listener);

    return () => {
      window.removeEventListener('resize', listener);
      window.removeEventListener('scroll', listener);
    };
  }, [ids, offset]);

  if (selectedTab === 'history') {
    return 'vehicle_history';
  }

  if (selectedTab === 'etahistory') {
    return 'eta_history';
  }

  return activeId;
};
